export default __webpack_public_path__ + "static/media/toShow-5-min.d4ff97a6.jpg";